import type { CmsContainerHeight, CmsContainerWidth, CmsMargin } from '@/services/cms-sdk';
import type { CmsBackgroundColor } from '@/services/cms-sdk/schemas/models/CmsBackgroundColor';

export const widthClassMap: Record<CmsContainerWidth, string> = {
    Full: '',
    ExtraWide: 'max-w-extra-wide',
    Wide: 'max-w-wide',
    Medium: 'max-w-medium',
    Narrow: 'max-w-narrow',
};
export function cmsWidthToClassName(width?: CmsContainerWidth) {
    return width ? widthClassMap[width] : '';
}

export const containerWidthBreakpoints: Record<CmsContainerWidth, string> = {
    Narrow: '49.5rem',
    Medium: '78.5rem',
    Wide: '85.5rem',
    ExtraWide: '91.5rem',
    Full: '',
} as const;

export const containerWidthLength: Record<CmsContainerWidth, number> = {
    Narrow: 768,
    Medium: 1232,
    Wide: 1344,
    ExtraWide: 1440,
    Full: 3840,
} as const;

export function getContainerWidthFraction(divider: number, width: CmsContainerWidth = 'Full') {
    return Math.ceil(containerWidthLength[width] / divider);
}

export function getImageSizesByContainerWidth(width: CmsContainerWidth = 'Full') {
    if (width === 'Full') {
        return '100vw';
    }

    return `
        (min-width:${containerWidthBreakpoints[width]}): ${containerWidthLength[width]}px,
        100vw
    `;
}

export const heightClassMap: Record<CmsContainerHeight, string> = {
    Fluid: '',
    Large: 'h-lg',
    Medium: 'h-md',
    Small: 'h-sm',
};
export function cmsHeightToClassName(height?: CmsContainerHeight) {
    return height ? heightClassMap[height] : '';
}
export const bgColorMap: Record<CmsBackgroundColor, string> = {
    None: '',
    Primary: 'bg-primary',
    PrimaryLight: 'bg-primary-light',
    Secondary: 'bg-secondary',
    SecondaryLight: 'bg-secondary-light',
    PrimaryGradient: 'primary-gradient',
    PrimaryGradientTransparent: 'primary-gradient-ts',
    PrimaryGradientTransparentReversed: 'primary-gradient-ts-reversed',
    SecondaryGradient: 'secondary-gradient',
    SecondaryGradientTransparent: 'secondary-gradient-ts',
    SecondaryGradientTransparentReversed: 'secondary-gradient-ts-reversed',
    Neutral: 'bg-neutral-content',
};
export function cmsBackgroundToClassName(color?: CmsBackgroundColor) {
    return color ? bgColorMap[color] : '';
}

export const marginMap: Record<CmsMargin, string> = {
    None: '',
    Default: 'mb-12',
    Small: 'mb-6',
    Large: 'mb-20',
};

export function cmsMarginToClassName(margin?: CmsMargin) {
    return margin ? marginMap[margin] : '';
}
